import { render, staticRenderFns } from "./awardEdit.vue?vue&type=template&id=4fc10afe&"
import script from "./awardEdit.vue?vue&type=script&lang=js&"
export * from "./awardEdit.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports